<template>
  <b-modal
    :id="`share-preview-${pageType}-${itemId}`"
    centered
    no-close-on-backdrop
    @hidden="$emit('modal-closed')"
  >
    <template #modal-header>
      <h3>{{ $t('previewLink.title') }}</h3>
    </template>
    <div class="p-4">
      <preview-link-share
        :page-id="pageType === 'page' ? itemId : null"
        :project-id="pageType === 'project' ? itemId : null"
        :group-domain="groupDomain"
        :slug-path="slugPath"
        :page-type="pageType"
        :show-title="false"
        @slug-changed="$emit('slug-changed')"
      />
    </div>
    <template #modal-footer="{ close }">
      <b-button
        class="p-3"
        block
        @click="close"
      >
        {{ $t('buttons.ok') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import PreviewLinkShare from '@/components/PreviewLinkShare.vue';

export default {
  name: 'ModalSharePreview',
  components: { PreviewLinkShare },
  props: {
    itemId: { type: Number, required: true },
    groupDomain: { type: String, required: true },
    slugPath: { type: String, required: true },
    pageType: { type: String, required: true },
  },
  mounted() {
    this.$bvModal.show(`share-preview-${this.pageType}-${this.itemId}`);
  },
};
</script>
